import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useLanguage } from "@/context/LanguageContext";
import { useUI } from "@/context/UIContext";
import { LEGAL } from "./legalContent";

export function LegalDialogs() {
  const { lang } = useLanguage();
  const { legalKey, closeLegal } = useUI();

  const open = !!legalKey;
  const doc = legalKey ? LEGAL[legalKey][lang] : null;

  return (
    <Dialog open={open} onOpenChange={(v) => (!v ? closeLegal() : null)}>
      <DialogContent
        className="max-w-2xl bg-[#0B0B0F] border border-[rgba(201,169,110,0.24)] text-foreground"
        data-testid={`legal-dialog-${legalKey || "none"}`}
      >
        {doc ? (
          <>
            <DialogHeader>
              <DialogTitle className="font-display text-2xl text-foreground">
                {doc.title}
              </DialogTitle>
              <DialogDescription className="text-xs text-muted-foreground">
                {doc.updated}
              </DialogDescription>
            </DialogHeader>
            <ScrollArea className="max-h-[60vh] pr-4">
              <div className="space-y-5">
                {doc.sections.map((s, i) => (
                  <div key={i}>
                    <h4 className="text-sm font-semibold text-[#D8C08A]">{s.h}</h4>
                    <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">
                      {s.p}
                    </p>
                  </div>
                ))}
              </div>
            </ScrollArea>
          </>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
